import { Elements, Loader } from '@tfo/common'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import GetAppIcon from '@material-ui/icons/GetApp';
import $http from '../../../../utils/$http'
import React, { useState } from 'react'
import './SignedDocuments.scss'
import { FileType, FileViewModel } from '../../ViewModels';
import fileDownload from 'js-file-download'

const { Paragraph } = Elements

export interface SignedDocumentsProps {
    files: FileViewModel[]
}

const SignedDocuments = ({
    files,
    intl,
}: SignedDocumentsProps & WrappedComponentProps) => {

    const signedDocuments = files.filter((item) => item.type === FileType.SignedDocument)

    const [isDownloading, setIsDownloading] = useState<boolean>(false)
    const downloadAuthorizedFile = (e: React.MouseEvent, file: FileViewModel) => {
        e.preventDefault()
        setIsDownloading(true)
        $http.get<Blob>(file.downloadUrlPath, 'blob')
            .then(data => fileDownload(data, file.fileName))
            .finally(() => setIsDownloading(false))
    }

    const hasSignedDocuments = signedDocuments && signedDocuments.length > 0

    return !hasSignedDocuments
        ? null
        : <>
            <div className='signed-documents'>
                <Paragraph className='header'>
                    {signedDocuments.length > 1 ? intl.formatMessage({ id: 'signedDocuments.fileList.header.plural' })
                        : intl.formatMessage({ id: 'signedDocuments.fileList.header.singular' })}
                </Paragraph>
                <ul className='signed-documents-list'>
                    {signedDocuments.map(file =>
                        <li className='download-file-link'>
                            <a href={file.downloadUrlPath} onClick={(e) => downloadAuthorizedFile(e, file)} >
                                <GetAppIcon /> {file.fileName}
                            </a>
                        </li>)}
                </ul>
            </div>
            {isDownloading && <Loader />}
        </>
}

export default injectIntl(SignedDocuments)